var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Metric_Selection"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Metric_Selection",
    "data-name": "Metric Selection",
    clipPath: "url(#clip-Metric_Selection)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "market-share",
    d: "M3.826,4.086l2.834.047a3.026,3.026,0,0,1-1.336,2.51Zm2.658-1.8V3.395l.323.009A3.35,3.35,0,0,0,6.484,2.288Zm-.312,1.1V1.775a3.373,3.373,0,0,0-.327-.382V3.375Zm-.638-.02V1.119A3.3,3.3,0,0,0,5.207.893V3.358l.327.01ZM4.9,3.346V.722A3.471,3.471,0,0,0,4.569.589V3.336l.328.01Zm-.639-.019V.5C4.144.47,4.032.448,3.933.432V3.319l.324.01ZM3.545,0a4.507,4.507,0,0,1,.95.151A3.765,3.765,0,0,1,7.216,3.6l.009.212L3.545,3.7ZM3.218,3.913l1.616,2.8A3.232,3.232,0,1,1,3.081.683Z",
    transform: "translate(1.622 6.113)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_156",
    "data-name": "Line 156",
    x2: 6.808,
    transform: "translate(11.521 7.328)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_157",
    "data-name": "Line 157",
    x2: 1.979,
    transform: "translate(11.521 9.947)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_159",
    "data-name": "Line 159",
    x2: 3.091,
    transform: "translate(15.5 9.947)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_158",
    "data-name": "Line 158",
    x2: 4.975,
    transform: "translate(11.521 12.565)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricSelection);
export default __webpack_public_path__ + "static/media/MetricSelection.9f8017b3d21d823fcf88dd918e116691.svg";
export { ForwardRef as ReactComponent };